// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"23f4516d","187":"cae32a39","215":"8149d062","237":"2ca2dd05","238":"74e369b1","415":"1f31500b","453":"e9874340","476":"3f5647cf","478":"fffce111","548":"5779cdc7","559":"d5ff54cf","698":"03d19152","708":"0da1a382","771":"3065e889","957":"c9b144b2"}[chunkId] + ".chunk.js";
};